import { DialogActions, DialogContentText } from "@mui/material";
import React from "react";
import Popup from "src/components/popup/Popup";
import CopyClipboard from "src/pages/AccessControl/pages/Re_fresh/CopyClipboard";

const RefreshViewDetailPopup = ({ openPopup, setOpenPopup, refreshDetail }) => {
  return (
    <Popup title="Detail" openPopup={openPopup} setOpenPopup={setOpenPopup}>
      <DialogContentText style={{ wordWrap: "break-word" }}>
        {refreshDetail?.string1}
      </DialogContentText>
      <DialogActions>
        <CopyClipboard dataCopy={refreshDetail?.string1} />
      </DialogActions>
    </Popup>
  );
};

export default RefreshViewDetailPopup;
